import { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
// ------ Services ------ //
import * as badgeManagementService from "../../../services/badgeManagementService"
// ------ Styles ------ //
import styles from './SnapshotMonitor.module.css'
// ------ Components ------ //
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import EventSnapshot from '../../../components/Badging/SnapshotMonitor/EventSnapshot'

const SnapshotMonitor = () => {
    const timeoutRef = useRef(null);
    const longTimeoutRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [loaded, setLoaded] = useState(false);
    const [timerFlag, setTimerFlag] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [eventSnapshots, setEventSnapshots] = useState([]);
    const changeDateFormat = dateStr => {
        if (!dateStr || dateStr === undefined)
        {
            return;
        }
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric' };
        const dateFormatted = date.toISOString( options);
        const returnDate = dateFormatted.split('T')[0];
        return returnDate
    }
    const createRequest = () => {
        const fieldsSave = {
            'startDate': startDate,
            'endDate': endDate,
        }
        return fieldsSave
    }
    const fetchEventSnapshots = async () => {
        try {
            let events = await badgeManagementService.getSnapshotMonitors(createRequest())
            if (events) {
                setEventSnapshots(events);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setLoaded(true);
    }
    const handleChange = async (e, name) => {
        let date = e.currentTarget.value;
        if (name === 'startDate') {
            setStartDate(date);
        }
        else {
            setEndDate(date);
        }
    }
    useEffect(() => {
        clearTimeout(longTimeoutRef.current);
        longTimeoutRef.current = setTimeout(() => {
            // Perform action here, e.g., 
            setTimerFlag(timerFlag ? false: true);
            fetchEventSnapshots();
        }, 50000); // Delay of 50000 milliseconds
    }, [loaded, timerFlag])
    useEffect(() => {
        if (startDate && endDate) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                // Perform action here, e.g., 
                fetchEventSnapshots();
            }, 1500); // Delay of 1500 milliseconds
        }

    }, [startDate, endDate])
    useEffect(() => {
        setStartDate(changeDateFormat(new Date(new Date().setMonth(new Date().getMonth() - 3))));
        setEndDate(changeDateFormat(new Date(new Date().setMonth(new Date().getMonth() + 1)))); // show future events as well
    }, [])
    return (
        
        <div id={styles.eventSnapshotsConfigurePage}>
            <h1>List of events and general statistics.</h1><br />
            <h2>Choose Start and End date range</h2><br />
            <p>
                Page refreshes every 50 seconds, or when date range is modified.
            </p>
            <div className={styles.dropdownContainer}>
            Start Date: 
                <input
                    className={styles.datePicker}
                    type="date"
                    value={changeDateFormat(startDate)}
                    onChange={(e) => handleChange(e, 'startDate')} //pass name as string
                    name="startDate"
                />
            </div>
            <div className={styles.dropdownContainer}>
            End Date:
                <input
                    className={styles.datePicker}
                    type="date"
                    onChange={(e) => handleChange(e, 'endDate')} //pass name as string
                    value={changeDateFormat(endDate)}
                    name="endDate"
                />
            </div>
            <>
                {
                    !loaded ? <LoadingSpinner /> :
                        <>
                            <br />
                            {
                                eventSnapshots && eventSnapshots.length > 0 ?
                                    <>
                                        <table className={styles.tableEventSnapshots}>
                                            <thead>
                                                <tr className={styles.trEventSnapshots}>
                                                    <th className={styles.thEventSnapshots}>
                                                        Client
                                                        <HoverButton
                                                            title={'Client name'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thEventSnapshots}>
                                                        Event
                                                        <HoverButton
                                                            title={'Event name'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thEventSnapshots}>
                                                        Event Id
                                                        <HoverButton
                                                            title={'Event id'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thEventSnapshots}>
                                                        Start Date
                                                        <HoverButton
                                                            title={'Event start date'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thEventSnapshots}>
                                                        Total Registered
                                                        <HoverButton
                                                            title={'Total count of registrants'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thEventSnapshots}>
                                                        Checked In
                                                        <HoverButton
                                                            title={'Registrants that have printed badges'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thEventSnapshots}>
                                                        Adhoc Print
                                                        <HoverButton
                                                            title={'Ahoc print count'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody key={eventSnapshots.length}>
                                                {eventSnapshots.map((item, index) => (
                                                    <EventSnapshot
                                                        index={index}
                                                        eventSnapshot={item}
                                                    >
                                                    </EventSnapshot>
                                                ))}
                                            </tbody>

                                        </table></>
                                        : <><div className={styles.errorEventSnapshots}>No events in specified range!</div>
                                    </>

                            }

                        </>
                }
            </>
            <br /><br />
            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default SnapshotMonitor;